import { Controller } from 'stimulus';

// Toggles aria-expanded on a trigger and shows/hides the panel referenced by
// aria-controls. Used by the Alert Outcomes Overview "Outcomes" table to
// reveal each outcome's nested action/observation rows.
export default class extends Controller {
  toggle(event) {
    event.preventDefault();

    const trigger = event.currentTarget;
    const panelId = trigger.getAttribute('aria-controls');
    if (!panelId) return;

    const panel = document.getElementById(panelId);
    if (!panel) return;

    const expanded = trigger.getAttribute('aria-expanded') === 'true';
    trigger.setAttribute('aria-expanded', expanded ? 'false' : 'true');
    panel.toggleAttribute('hidden', expanded);
  }
}
